(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["webcam-polo-nord"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeWebcam = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const allSlides = Array.from(root.querySelectorAll('.polo-webcam__slide'));
      const empty = root.querySelector('.polo-webcam__empty');
      const clock = root.querySelector('.polo-webcam__clock');
      const interval = Math.max(Number(root.dataset.interval) || 6000, 2000);
      let timer;
      let currentIndex = 0;

      const isInRange = (hour, start, end) => {
        if (start === end) return true;
        if (start < end) return hour >= start && hour < end;
        return hour >= start || hour < end;
      };

      const getActiveSlides = () => {
        const hour = new Date().getHours();
        return allSlides.filter((slide) => {
          const start = Number(slide.dataset.startHour);
          const end = Number(slide.dataset.endHour);
          return isInRange(hour, start, end);
        });
      };

      const showSlide = (slides, index) => {
        allSlides.forEach((slide) => {
          slide.classList.remove('is-active');
          slide.hidden = true;
        });

        if (!slides.length) {
          empty.textContent = root.dataset.emptyMessage;
          empty.hidden = false;
          return;
        }

        empty.hidden = true;
        const selected = slides[index % slides.length];
        selected.hidden = false;
        requestAnimationFrame(() => selected.classList.add('is-active'));
      };

      const refresh = () => {
        window.clearInterval(timer);
        currentIndex = 0;
        const slides = getActiveSlides();
        showSlide(slides, currentIndex);

        if (slides.length > 1) {
          timer = window.setInterval(() => {
            currentIndex = (currentIndex + 1) % slides.length;
            showSlide(slides, currentIndex);
          }, interval);
        }
      };

      const updateClock = () => {
        clock.textContent = new Intl.DateTimeFormat('it-IT', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(new Date());
      };

      updateClock();
      refresh();
      window.setInterval(updateClock, 1000);
      window.setInterval(refresh, 60000);
    };

    const boot = () => {
      document.querySelectorAll('[id^="PoloWebcam-"]').forEach(initializeWebcam);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeWebcam(event.target.querySelector('[id^="PoloWebcam-"]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
